const initialState = {
    loading:false,
    rewardItems: [],
    redeemRewardItems: [],
    totalCoins: 0,
    studentCoins: 0,
    redeemButtonStatus: false,
    rewardRedemptionLog: [],
    campaigns: [],
};

const rewardReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_LOADING':
            return { ...state, loading: action.loading };
        case 'SET_REWARD_ITEMS':
            return { ...state, rewardItems: action.rewardItems };
        case 'SET_REDEEM_REWARD_ITEMS':
            return { ...state, redeemRewardItems: action.redeemRewardItems };
        case 'SET_TOTAL_COINS':
            return { ...state, totalCoins: action.totalCoins };
        case 'SET_STUDENT_COINS':
            return { ...state, studentCoins: action.studentCoins };
        case 'SET_REDEEM_BUTTON_STATUS':
            return { ...state, redeemButtonStatus: action.redeemButtonStatus };
        case 'SET_REWARD_REDEMPTION_LOG':
            return { ...state, rewardRedemptionLog: action.rewardRedemptionLog };
        case 'SET_CAMPAIGNS':
            return { ...state, campaigns: action.campaigns };
        default:
            return state;
    }
}

export { rewardReducer as default }